module.exports = __webpack_public_path__ + "static/media/lock-solid-white-01.c467df7a.png";